const _ = require('underscore');
const Mn = require('backbone.marionette');
const Tooltip = require('common/ui/view/behavior/tooltip');
const AnnouncementCollectionFactory = require('feedback/domain/factory/announcement/collection');
const AnnouncementView = require('feedback/ui/header/announcement');
const ReviewView = require('notify/ui/view/header/review');
const MyTaskView = require('my/ui/header/task');
const LicenseHeaderView = require('common/ui/view/header/license');
const Template = require('balus/ui/template/header/index.hbs');
const GroupTemplate = require('balus/ui/template/header/group.hbs');
const UserView = require('common/ui/view/header/user');
const DebugContextRepository = require('common/util/debug-context/debug-context-repository');

const GroupView = Mn.View.extend({
    template: GroupTemplate,
    templateContext: function() {
        return {
            path: this.model.path()
        }
    }
});

module.exports = Mn.View.extend({
    className: 'navbar navbar-fixed-top',
    attributes: {
        id: 'header',
        role: 'navigation'
    },
    template: Template,
    ui: {
        'title': '.title'
    },
    regions: {
        'user': '.navbar-user',
        'announce': '.navbar-announce',
        review: '.navbar-review',
        task: '.navbar-task',
        group: '.group',
        groupLicense: '.group-license'
    },
    childViewTriggers: {
        'toggle:review': 'toggle:review',
        'toggle:task': 'toggle:task'
    },
    childViewEvents: {
        'toggle:review': 'hideTooltip'
    },
    behaviors: [Tooltip],

    templateContext: function() {
        const debugContext = (new DebugContextRepository()).fetch();

        return {
            debugContext: debugContext.toTemplateContext()
        };
    },

    onRender: function() {
        const context = this.getOption('context');
        const user = context.getUser();

        this.showChildView('user', new UserView({model: user}));

        const language = user && user.get('language') ? user.get('language') : 'ja';

        const collection = AnnouncementCollectionFactory.getCollection();
        collection
            .fetchFirstPage()
            .then(() => {
                const availableAnnouncements = _.filter(collection.models, a => {
                    return a.isDisplayed();
                });
                if(availableAnnouncements.length > 0) {
                    const model = availableAnnouncements[_.random(0, availableAnnouncements.length - 1)];
                    this.showChildView('announce', new AnnouncementView({
                        model: model
                    }));
                }
            });

        if(user && user.id) {
            this.showChildView('review', new ReviewView());
            this.showChildView('task', new MyTaskView());
        }
    },

    showGroup: function(group) {
        this.getRegion('group').$el.show();
        this.showChildView('group', new GroupView({
            model: group
        }));
    },

    hideGroup: function() {
        this.getRegion('group').empty();
        this.getRegion('group').$el.hide();
    },

    showGroupLicense: function(group) {
        const context = this.getOption('context');
        const user = context.getUser();

        if(!group.isMember(user)) {
            return;
        }

        const license = group.getMainLicense();
        if(license) {
            this.showChildView('groupLicense', new LicenseHeaderView({
                model: license
            }));
        }
    },

    hideGroupLicense: function(group) {
        this.getRegion('groupLicense').empty();
    },

    hideTooltip: function() {
        this.$('[data-toggle="tooltip"]').tooltip('hide');
    },

    activateReview: function() {
        this.getChildView('review') && this.getChildView('review').activate();
        this.deactivateTask();
    },

    deactivateReview: function() {
        this.getChildView('review') && this.getChildView('review').deactivate();
    },

    activateTask: function() {
        this.getChildView('task') && this.getChildView('task').activate();
        this.deactivateReview();
    },

    deactivateTask: function() {
        this.getChildView('task') && this.getChildView('task').deactivate();
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/header/index.js